import { DescriptionSource, displayMetricType, MetricType } from '../client/metadata';

export function getMetadataTooltipDOM(
  payload: {
    metricName?: string;
    type?: MetricType;
    description?: string;
    descriptionSource?: DescriptionSource;
    subType?: string;
    expandedQuery?: string;
    onExpandQuery?: () => void;
  },
  options: {
    padding?: string;
  } = {}
) {
  const { metricName, type, description, subType, expandedQuery, onExpandQuery, descriptionSource } = payload;
  const { padding } = options;

  const viewLabelsHref = `/metrics/catalog?metric=${encodeURIComponent(metricName ?? '')}&tab=labels`;

  const div = document.createElement('div');
  div.innerHTML = withPadding(
    [
      '<div style="font-size: 12px; line-height: 1.5;">',
      subType ? `<div style="margin-bottom: 4px; opacity: 0.5;"><i>${escapeHTML(subType)}</i></div>` : '',
      `<div style="margin-bottom: 8px; word-break: break-all;"><strong>${escapeHTML(metricName ?? '')}</strong></div>`,
      `<div style="margin-bottom: 8px;">${escapeHTML(displayMetricType(type))}</div>`,
      description
        ? `<div style="margin-bottom: 16px; max-width: 700px;">${escapeHTML(description)}${descriptionSource === 'GENERATED' ? '<div style="opacity: 0.5; margin-top: 4px;">Generated by AI</div>' : ''}</div>`
        : '',
      '<div style="margin-bottom: 4px; display: flex; gap: 8px;">',
      `<a class="btn" style="font-size: inherit; padding: 0 8px; background: transparent;" target="_blank" href="${viewLabelsHref}">View labels</a>`,
      expandedQuery
        ? '<a class="btn expand-query" style="font-size: inherit; padding: 0 8px; background: transparent;" target="_blank">Expand metric</a>'
        : '',
      '</div>',
      '</div>',
    ].join(''),
    padding
  );

  if (onExpandQuery) {
    const expandButton = div.querySelector('.expand-query');
    if (expandButton) {
      expandButton.addEventListener('click', onExpandQuery);
    }
  }

  return div;
}

// helper function to add padding to the tooltip
export const withPadding = (str: string, padding: string = '4px') => {
  return `<div style="padding: ${padding};">${str}</div>`;
};

/**
 * Escape HTML special characters in a string to prevent XSS attacks.
 */
function escapeHTML(str: string) {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
